import { PredictionFeedbackCauseType } from "shared";

import { useCreatePredictionFeedback } from "./useCreatePredictionFeedback";
import { usePredictionFeedback } from "./usePredictionFeedback";
import { useUpdatePredictionFeedback } from "./useUpdatePredictionFeedback";

interface UsePredictionFeedbackProps {
  predictionId?: string;
  enabled?: boolean;
}

export type SubmitPredictionFeedbackPayload = {
  rating: number;
  comment?: string;
  causes?: PredictionFeedbackCauseType[];
  actualMaterialPrice?: number;
  actualAddedValuePrice?: number;
  actualTotalPrice?: number;
};

export const useSubmitPredictionFeedback = ({ predictionId }: UsePredictionFeedbackProps) => {
  const { predictionFeedback, isLoading } = usePredictionFeedback(predictionId);

  const { createPredictionFeedback, isPending: createFeedbackMutation } =
    useCreatePredictionFeedback();
  const { updatePredictionFeedback, isPending: updateFeedbackMutation } =
    useUpdatePredictionFeedback();

  const submitFeedback = (payload: SubmitPredictionFeedbackPayload) => {
    if (predictionFeedback) {
      updatePredictionFeedback({
        feedbackId: predictionFeedback.id,
        payload,
      });
    } else {
      createPredictionFeedback({
        predictionId,
        payload,
      });
    }
  };
  return {
    predictionFeedback,
    isLoading,
    submitFeedback,
    isSubmitting: createFeedbackMutation || updateFeedbackMutation,
  };
};
